import React from 'react';
import logo from './logo.svg';
import './App.css';
import CounterApp from './counter/CounterApp';

function App() {
    return (
        <div className='App'>
            <CounterApp />
        </div>
    );
}

export default App;
